import { render, staticRenderFns } from "./input-more.vue?vue&type=template&id=3d5df6b4&scoped=true"
import script from "./input-more.vue?vue&type=script&lang=js"
export * from "./input-more.vue?vue&type=script&lang=js"
import style0 from "./input-more.vue?vue&type=style&index=0&id=3d5df6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5df6b4",
  null
  
)

export default component.exports